import type { CreatePasswordProps } from 'src/components/types/types';
import http from '../common/http-auth'

interface UserFormInputs {
    "firstName": string;
    "lastName": string;
    "email": string;
    "roleId":number;
    "createdBy"?: number;
}

interface UserDeleteIds {
    "userId": number;
}
interface UserDeleteProps {
    "modifiedBy": number;
    "userLst": UserDeleteIds[];
}

interface ChangePasswordProps {
    "password": string;
    "confirmPassword": string;
    "userId"?: number;
  }


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllUsersData = async () => {
    const response = http.get(`/user/selectallusers`)

    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const addUserData = async (data: UserFormInputs) => {
    const response = http.post(`/user/register`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getUserById = async (id?: string) => {
    const response = http.get(`/user/${id !== undefined ? id : ''}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateUserData = async (data: UserFormInputs) => {
    const response = http.put(`/user/update`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const deleteUserData = async (data: UserDeleteProps) => {
    const response = http.post(`/user/delete`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const changeUserPassword = async (data: ChangePasswordProps) => {
    const response = http.post(`/user/updatepassword`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const createUserPassword = async (data: CreatePasswordProps) => {
    const response = http.post(`authentication/passwordreset`, data)
    return response;
}